import React, { Component } from 'react';
import {
    Jumbotron, Card, CardImg, CardBody, CardTitle, CardText, CardDeck, Button, Row, Col, UncontrolledCarousel
} from 'reactstrap';
import { Link } from 'react-router-dom';
import './App.css';

class About extends Component {

    render() {
        return (
            <div>
                <AboutNYB />
                <WhatWeDo />
                <ContactUs />
                <MeetTheNYB />
                <JoinNYB />
                <Film />
                <RYB />
                <UL />
                <PinP />
                <Service />
                <Marketing />
                <NYBLogo />
            </div>
        )
    }
}

class AboutNYB extends Component {
    render() {
        return (
            <Jumbotron>
                <Row>
                    <Col md='8'>
                        <h1> The United States Pony Clubs National Youth Board </h1>
                        <p> It is the mission of the National Youth Board (NYB) to act as a liaison between the youth membership of
                            USPC and the Board of Governors by communicating the needs, ideas, and concerns of USPC youth to governing
                            officers. NYB members provide member insight and bring forward ideas and proposals regarding important issues,
                    as well as conduct independent projects under the direction of the national office. </p>
                        <p> The current NYB Chair and the previous Chair also serve as full members on the USPC Board of Governors.
                    In addition, members of the NYB represent the youth members on various Board and Council Committees.</p>


                    </Col>

                    <Col>
                        <img src='./img/board.png' alt='USPC NYB Board in Seattle' height='250px' width='350px' style={{ borderRadius: '5px' }} />
                    </Col>
                </Row>
            </Jumbotron>
        )
    }
}

class WhatWeDo extends Component {
    render() {

        let items = [
            {
                src: './img/film.png',
                altText: 'Slide 1',
                caption: '',
                header: '',
                key: '2'
            },
            {
                src: './img/leadership.png',
                altText: 'Slide 2',
                caption: 'USPC NYB',
                header: 'Leadership',
                key: '3'
            },
            {
                src: './img/lr.png',
                altText: 'Slide 3',
                caption: 'USPC NYB',
                header: 'LRK3DE',
                key: '4'
            },
            {
                src: './img/compete.png',
                altText: 'Slide 4',
                caption: 'USPC NYB',
                header: 'Compete',
                key: '5'
            },
            {
                src: './img/serve.png',
                altText: 'Slide 4',
                caption: 'USPC NYB',
                header: 'Serve',
                key: '6'
            }
        ]

        return (
            <div>

                <Row style={{ paddingLeft: '2em' }}>
                    <Col md='6'>
                        <Card style={{ marginBottom: '1em' }} className="com-card">
                        <Link to='/nyb' style={{ color: 'black', textDecoration: 'none' }}>
                            <Row>
                                <Col md='3'>
                                    <CardImg style={{ height: '125px', width: '125px' }} src='./img/keelyryb.png' alt='Jessica Flores' />
                                </Col>
                                <Col>
                                    <CardBody>
                                        <CardTitle style={{ fontSize: '24px', fontWeight: 'bold' }}> Regional Youth Board Committee </CardTitle>
                                        <CardText> Foster connections with RYB's around the Nation </CardText>
                                    </CardBody>
                                </Col>
                            </Row>
                            </Link>
                        </Card>
                        <Card style={{ marginBottom: '1em' }} className="com-card">
                        <Link to='/nyb' style={{ color: 'black', textDecoration: 'none' }}>
                            <Row>
                                <Col md='3'>
                                    <CardImg style={{ height: '125px', width: '125px' }} src='./img/upperl.png' alt='Upper Level' />
                                </Col>
                                <Col>
                                    <CardBody>
                                        <CardTitle style={{ fontSize: '24px', fontWeight: 'bold' }}> Upper Level Committee </CardTitle>
                                        <CardText> Keep Upper Level Members Engaged </CardText>
                                    </CardBody>
                                </Col>
                            </Row>
                            </Link>
                        </Card>
                        <Card style={{ marginBottom: '1em' }} className="com-card">
                        <Link to='/nyb' style={{ color: 'black', textDecoration: 'none' }}>
                            <Row>
                                <Col md='3'>
                                    <CardImg style={{ height: '125px', width: '125px' }} src='./img/pin.png' alt='USPC Pin' />
                                </Col>
                                <Col>
                                    <CardBody>
                                        <CardTitle style={{ fontSize: '24px', fontWeight: 'bold' }}> Pin Promise Committee </CardTitle>
                                        <CardText> #PonyClubProud </CardText>
                                    </CardBody>
                                </Col>
                            </Row>
                            </Link>
                        </Card>
                        <Card style={{ marginBottom: '1em' }} className="com-card">
                        <Link to='/nyb' style={{ color: 'black', textDecoration: 'none' }}>
                            <Row>
                                <Col md='3'>
                                    <CardImg style={{ height: '125px', width: '125px' }} src='./img/service.png' alt='Service' />
                                </Col>
                                <Col>
                                    <CardBody>
                                        <CardTitle style={{ fontSize: '24px', fontWeight: 'bold' }}> Servie Committee </CardTitle>
                                        <CardText> Giving Back to the Community </CardText>
                                        
                                    </CardBody>
                                </Col>
                            </Row>
                            </Link>
                        </Card>
                        <Card style={{ marginBottom: '1em' }} className="com-card">
                        <Link to='/nyb' style={{ color: 'black', textDecoration: 'none' }}>
                            <Row>
                                <Col md='3' className='pic'>
                                    <CardImg style={{ height: '125px', width: '125px' }} src='./img/market.png' alt='Marketing' />
                                </Col>
                                <Col>
                                    <CardBody>
                                        <CardTitle style={{ fontSize: '24px', fontWeight: 'bold' }}> Marketing Committee </CardTitle>
                                        <CardText> Follow us on Facebook! </CardText>
                                    </CardBody>
                                </Col>
                            </Row>
                            </Link>
                        </Card>
                    </Col>
                    <div className='pictures'>
                        <UncontrolledCarousel classNam='slides' items={items} controls={true} ></UncontrolledCarousel>

                        <h3 style={{ paddingTop: '2em', textAlign: 'center' }}> Enter the USPC NYB Film Competition! </h3>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button color='primary' style={{ marginLeft: '0.5em' }}> <Link to='/nyb' style={{ color: 'white' }}> Learn More </Link> </Button>
                        </div>


                        <h3 style={{ paddingTop: '2em', textAlign: 'center' }}> Follow the NYB on Facebook </h3>
                        <a href='https://www.facebook.com/nationalyouthboard/' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src='./img/facebook.png' alt='USPC NYB Facebook' height='100px' />
                        </a>
                    </div>
                    <Col>
                    </Col>
                </Row>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin:'3em' }}>
                        <Button color='primary' style={{ marginLeft: '0.5em' }}> <Link to='/nyb' style={{ color: 'white' }}> Learn more about NYB what the NYB does here! </Link> </Button>
                        </div>


            </div>
        )
    }
}

class ContactUs extends Component {
    render() {
        return (
            <Jumbotron>
                <h1 style={{ textAlign: 'center' }}> Contact the NYB </h1>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p style={{ paddingTop: '1em' }}> nybchair@ponyclub.org </p>
                </div>
            </Jumbotron>
        )
    }
}

class MeetTheNYB extends Component {
    render() {
        return (
            <div>
                <h1 style={{ textAlign: 'center' }}> USPC 2020 National Youth Board Delegates </h1>
                <CardDeck style={{ padding: '1em' }}>
                    <Card>
                        <CardImg height="175px" src='./img/jessica.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Jessica Flores </CardTitle>
                            <CardText> NYB Chair | Middle California Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Nila.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Nila Venkat  </CardTitle>
                            <CardText> Member | Middle California Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Ryder.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Ryder Black  </CardTitle>
                            <CardText> Technology Coordinator | Northwest Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height="175px" src='./img/Virginia.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Virginia Carpenter </CardTitle>
                            <CardText> RYB Committee Chair | Virginia Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Alex.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Alex McKinley  </CardTitle>
                            <CardText> Service Committee Chair | Great Lakes Region  </CardText>
                        </CardBody>
                    </Card>
                </CardDeck>

                <CardDeck style={{ padding: '1em' }}>
                    <Card>
                        <CardImg height='175px' src='./img/Madyson.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Madisyn DeCant  </CardTitle>
                            <CardText> Member | Old Dominion Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height="175px" src='./img/Elizabeth.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Elizabeth Larson </CardTitle>
                            <CardText> Member | Oregon Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/keely.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Keely Bechtol  </CardTitle>
                            <CardText> Member | Midsouth Region </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Grace.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Grace Mitchinson  </CardTitle>
                            <CardText> Social Media Coordinator | Great Lakes Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height="175px" src='./img/Brianna.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Brianna Nevins </CardTitle>
                            <CardText> Secretary | Lake Shore Region  </CardText>
                        </CardBody>
                    </Card>
                </CardDeck>


                <CardDeck style={{ padding: '1em' }}>
                    <Card>
                        <CardImg height='175px' src='./img/rachel.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Rachel Rozenboom  </CardTitle>
                            <CardText> Treasurer | Midsouth Region </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Cora.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Cora Swindale  </CardTitle>
                            <CardText> Vice-Chair | Northwest Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height="175px" src='./img/Renata.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Renata Petraitis </CardTitle>
                            <CardText> Upper Level Committee Chair | Virginia Region  </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/olivia.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Olivia Crespo  </CardTitle>
                            <CardText> Marketing Committee Chair | New Jersey Region </CardText>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardImg height='175px' src='./img/Tanner.png' alt='Jessica Flores' />
                        <CardBody>
                            <CardTitle style={{ fontWeight: 'bold', fontSize: '24px' }}> Tanner Kooistra  </CardTitle>
                            <CardText> Advisor | Northwest Region  </CardText>
                        </CardBody>
                    </Card>
                </CardDeck>
            </div>
        )
    }
}

class JoinNYB extends Component {
    render() {
        return (
            <Jumbotron >
                <h1 style={{ textAlign: 'center' }}> Join the NYB! </h1>
                <p style={{ textAlign: 'center' }}> Delegates of the NYB must be between 18 - 23 years of age, highly motivated and dedicated, and have strong
                    leadership and communication skills. It is expected that delegates maintain open communication with the members
                    they represent, providing an efficient medium for communication in a professional manner. Their work requires regular
                    communication with other NYB members, USPC Board Committee members, USPC staff, and the greater USPC community.
                </p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Button href='https://www.ponyclub.org/Members/Leadership/NatYouthBoard/BecomeNYBDelegate.aspx'> Apply Now </Button>
                </div>
            </Jumbotron>
        )
    }
}

class Film extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - NYB Film Competition - </h1>
                </div>
                <Col>
                <div style={{padding:'2em'}}>
                <p style={{textAlign:'center'}}> The National Youth Board challenges USPC to show us what makes YOU #ponycluproud in 1 minute or less in the 
                    2020 USPC Film Competition. Show us why you love Pony Club, teach something relevant to your next certification, 
                    or make a fun barn skit! Be creative with content and aim to inspire Pony Club members from around the nation!
                </p>
                <p style={{textAlign:'center'}}>
                        Video
                     submissions are due to NYBchair@ponyclub.org by December 31, 2020. Footage must meet Pony Club horse management and 
                     safety expectations at all times. Awards will be presented at the 2021 Symposium and Convention in St. Louis, 
                     Missouri. Let's get filming! 
                </p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                <img src='./img/film2.png' alt='Film Competition Logo' height='600px'></img>
                </div>
                </Col>
            </div>
        )
    }
}

class RYB extends Component {
    render() {
        return (
                <Jumbotron>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Regional Youth Boards - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <p> Information to come! </p>
                </div>
                </Jumbotron>
        )
    }
}

class UL extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Upper Level Opportunities - </h1>
                </div>
                <CardDeck style={{paddingTop:'2em'}}>
                    <Card>
                        <CardImg src='./img/research.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Research Fair at Symposium </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Put your research skills to the test with the USPC Research Fair hosted by the Grayson-Jockey Club Research Foundation!  </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/ContentDocs/AnnualMeeting/2020%20RPF%20entry.pdf'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/inter.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > International Exchange </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Ever wanted to compete internationally? Now is your chance to represent team USA and USPC! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/InternationalExchanges/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/nyc.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > National Youth Congress </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Learn valuable leaderhsip skills while having fun with like minded Pony Club members from around the nation! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/NatYouthCongress/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/leaders.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > National Youth Board </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Have fun and make a difference in Pony Club with Pony Club members from around the nation!  </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/NatYouthBoard/Default.aspx'> Learn More </Button>
                    </Card>
                </CardDeck>
                <CardDeck style={{ marginTop: '1em' }}>
                    <Card>
                        <CardImg src='./img/vi.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Visiting Instructor Program </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Share your knowledge with Pony Clubs across the nation through the visiting instructor program! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/Leadership/Visiting/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/champs.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > College Scholarships </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Headed off to College? Take advantage of USPC college scholarships to help finance those textbooks! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Members/CollegeScholarships/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/teach.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Examiner, Volunteer, Teacher </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Ready to examine younger members, teach the next generation of horsemen, or learn what it is like on the logistics side of rallies? </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Certifications/Default.aspx'> Learn More </Button>
                    </Card>
                    <Card>
                        <CardImg src='./img/college.png' alt='research' />
                        <CardTitle style={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }} > Championships </CardTitle>
                        <CardText style={{ textAlign: 'center' }}> Represnt your club, region, and team at the national level while serving as a role model for younger members! </CardText>
                        <Button color='primary' href='https://www.ponyclub.org/Events/Championships/'> Learn More </Button>
                    </Card>
                </CardDeck>
            </div>
        )
    }
}

class PinP extends Component {
    render() {
        return (
            <Jumbotron style={{marginTop:'2em'}}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Pin Promise - </h1>
                </div>

                <Row style={{display:'flex', justifyContent: "center", alignItems: "center"}}>

                    <img src='./img/pin1.png' alt='pin photo1' width='250px' height='175px' />
                    <img src='./img/pin5.png' alt='pin photo2' width='250px' height='175px' />
                    <img src='./img/pin2.png' alt='pin photo3' width='250px' height='175px' />
                    <img src='./img/pin3.png' alt='pin photo4' width='250px' height='175px' />
                    <img src='./img/pin4.png' alt='pin photo5' width='250px' height='175px' />
                    <img src='./img/pin6.png' alt='pin photo6' width='250px' height='175px' />

                </Row>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <h3> Where do you wear your Pony Club pin? </h3>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Come find the NYB at LRK3DE and support USPC by wearing your Pony Club pin! </p>
                </div>

            </Jumbotron>
        )
    }
}

class Service extends Component {
    render() {
        return (
            <div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Service - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src='./img/ser.png' alt='service' width='400px' style={{ borderRadius: '5px' }} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '1em' }}>
                    <p> Every year, the National Youth Board completes an annual service project during the USPC symposium and convention!</p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> In 2020, we volunteered at <a href='https://www.littlebit.org/'> Little Bits Therapeutic Riding Center </a></p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Please join our month of service in August and share a service project you, your club, or friends did with the NYB for a chance to be featured on our Facebook page! </p>
                </div>

            </div>
        )
    }
}

class Marketing extends Component {
    render() {
        return (
            <Jumbotron>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '3em' }}>
                    <h1> - Marketing - </h1>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <p> Our marketing team is hard at work to get information out to USPC members. Always be on the look out for exciting opportunities and news shared by our borad on our Facebook page!  </p>
                </div>
                <h3 style={{ paddingTop: '2em', textAlign: 'center' }}> Follow the NYB on Facebook </h3>
                <a href='https://www.facebook.com/nationalyouthboard/' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src='./img/facebook.png' alt='USPC NYB Facebook' height='100px' />
                </a>
            </Jumbotron>
        )
    }
}


class NYBLogo extends Component {
    render() {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src='./img/nyb-logo.png' alt='NYB Logo' width='400px' height='100px' />
            </div>
        )
    }
}

export default About;